import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as userService from '_services/users'

export const LOGIN = defineAction('LOGIN')
export const LOGOUT = 'LOGOUT'
export const SIGNUP = defineAction('SIGNUP')
export const FORGOT = defineAction('FORGOT')
export const RESET = defineAction('RESET')
export const SUBSCRIBE = defineAction('SUBSCRIBE')
export const UNSUBSCRIBE = defineAction('UNSUBSCRIBE')
export const GET_PROFILE_INFO = defineAction('GET_PROFILE_INFO')
export const DELETE_ACCOUNT = defineAction('DELETE_ACCOUNT')
export const UPDATE_PROFILE = defineAction('UPDATE_PROFILE')
export const UPDATE_PASSWORD = defineAction('UPDATE_PASSWORD')
export const TOGGLE_UPDATE = defineAction('TOGGLE_UPDATE')
export const UPDATE_LAST_ACTIVITY_AT = defineAction('UPDATE_LAST_ACTIVITY_AT')
export const CONFIRM_EMAIL = defineAction('CONFIRM_EMAIL')
export const RESEND_CONFIRM_EMAIL = defineAction('RESEND_CONFIRM_EMAIL')

export const login = payload => dispatch =>
  dispatch({
    type: LOGIN.ACTION,
    payload: userService.login(payload),
  })

export const logout = () => dispatch =>
  dispatch({
    type: LOGOUT,
  })

export const signup = payload => dispatch =>
  dispatch({
    type: SIGNUP.ACTION,
    payload: userService.signup(payload),
  })

export const forgot = payload => dispatch =>
  dispatch({
    type: FORGOT,
    payload: userService.forgot(payload),
  })

export const reset = payload => dispatch =>
  dispatch({
    type: RESET.ACTION,
    payload: userService.reset(payload),
  })

export const getProfileInfo = () => (dispatch, getState) =>
  dispatch({
    type: GET_PROFILE_INFO.ACTION,
    payload: userService.getProfileInfo(getState().user.get('token')),
  })

export const subscribe = payload => (dispatch, getState) =>
  dispatch({
    type: SUBSCRIBE.ACTION,
    payload: userService
      .subscribe(getState().user.get('token'))(payload)
      .then(() => userService.getProfileInfo(getState().user.get('token'))),
  })

export const unsubscribe = () => (dispatch, getState) =>
  dispatch({
    type: UNSUBSCRIBE.ACTION,
    payload: userService
      .unsubscribe(getState().user.get('token'))
      .then(() => userService.getProfileInfo(getState().user.get('token'))),
  })

export const toggleUpdate = () => (dispatch, getState) =>
  dispatch({
    type: TOGGLE_UPDATE.ACTION,
    payload: userService
      .toggleUpdate(getState().user.get('token'))
      .then(() => userService.getProfileInfo(getState().user.get('token'))),
  })

export const deleteAccount = () => (dispatch, getState) =>
  dispatch({
    type: DELETE_ACCOUNT.ACTION,
    payload: userService.deleteAccount(getState().user.get('token')),
  })

export const updateProfile = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_PROFILE.ACTION,
    payload: userService
      .updateProfile(getState().user.get('token'))(payload)
      .then(() => userService.getProfileInfo(getState().user.get('token'))),
  })

export const updatePassword = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_PASSWORD.ACTION,
    payload: userService.updatePassword(getState().user.get('token'))(payload),
  })

export const updateLastActivityAt = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_LAST_ACTIVITY_AT.ACTION,
    payload: userService.updateLastActivityAt(getState().user.get('token'))(payload),
  })

export const confirmEmail = payload => (dispatch, getState) =>
  dispatch({
    type: CONFIRM_EMAIL.ACTION,
    payload: userService
      .confirmEmail(getState().user.get('token'))(payload)
      .then(() => userService.getProfileInfo(getState().user.get('token'))),
  })

export const resendConfirmEmail = () => (dispatch, getState) =>
  dispatch({
    type: RESEND_CONFIRM_EMAIL.ACTION,
    payload: userService.resendConfirmEmail(getState().user.get('token')),
  })



// WEBPACK FOOTER //
// ./src/modules/user/actions.js